export default "__VITE_ASSET__CYHwzx0s__"